module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amap-wrapper",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-amap-search-box', {
    staticClass: "search-box",
    attrs: {
      "search-option": _vm.searchOption,
      "on-search-result": _vm.onSearchResult,
      "events": _vm.events
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "amap-wrapper"
  }, [_c('el-amap', {
    attrs: {
      "vid": 'amap-vue',
      "center": _vm.mapCenter,
      "zoom": _vm.zoom
    }
  }, [_c('el-amap-marker', {
    attrs: {
      "position": _vm.marker.position,
      "events": _vm.marker.events,
      "visible": _vm.marker.visible,
      "draggable": _vm.marker.draggable
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f9493b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-map/bo-map.vue
// module id = 237
// module chunks = 6